<template>
  <div class="modal" @click.self="closeModal">
    <div class="modal-dialog modal-dialog-lg">
      <div class="modal-title flex flex-end"><span class="modal-close" @click="closeModal"><i class="icon-close"></i></span></div>
      <div class="flex flex-v-top modal-content">
        <img src="../assets/img/gena-skate.svg" width="100" height="150" alt="Only premium" class="mr-3 premium-purchased-image">
        <div class="text-huge">
          <p>{{$lang.messages.premium_success_modal.text_part_1}}</p>
          <p class="mb-2">{{$lang.messages.premium_success_modal.text_part_2}}</p>
          <p class="mb-2">{{$lang.messages.premium_success_modal.text_part_3}}</p>
          <p v-if="newUser" class="form-error">
            For now you don't have any related extension installed. <br>
            To do that you can do <a href="#">here</a>
          </p>
          <div class="row mb-3">
            <div class="col-xs-9">
              <button class="btn btn-main w-100" @click.stop="closeModal">{{$lang.messages.premium_success_modal.button}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PremiumPurchasedModal',
  props: ['newUser'],
  methods: {
    closeModal () {
      this.$emit('closemodal')
    }
  }
}

</script>

<style scoped lang="scss">
@media all and (max-width: 767px){
  .modal-dialog-lg {
    .text-huge {
      font-size: 22px;
    }
  }

  .modal-content {
    justify-content: center;
    padding-top: 0;
  }

  .premium-purchased-image {
    margin-right: 15px !important;
  }
}
</style>
